import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/img/Icons/iconRight.svg'
import _imports_1 from '@/assets/img/Icons/hidden.svg'
import _imports_2 from '@/assets/img/Icons/un-hidden.svg'


const _hoisted_1 = { class: "test" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = { class: "ui_continue_button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "beneficiary_add_btn-black" }
const _hoisted_8 = { class: "beneficiary_add_btn" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_10 = { class: "m-4" }
const _hoisted_11 = { class: "field form-group" }
const _hoisted_12 = { class: "password" }
const _hoisted_13 = {
  key: 0,
  src: _imports_1
}
const _hoisted_14 = {
  key: 1,
  src: _imports_2
}
const _hoisted_15 = { class: "d-flex flex-wrap" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-3",
  src: _imports_0
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "pt-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "ui-select-autocomplete")
], -1)

import { Countries } from "@/models/const/countries";

// Импорты из Vue 3 Composition API
import { ref, computed, onMounted, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'test-page',
  setup(__props) {

const countries = Countries;
const country = ref();

function changeCountry(value) {}
// // Определение пропсов компонента
// const props = defineProps({
//   isCompact: { type: Boolean, value: true },
//   msg: { type: String, default: "" },
// });

// // Определение эмиттеров событий компонента
// const emits = defineEmits<{
//   clickLogout: [], // Событие при клике на кнопку "Выход"
//   "update:message": [string]; // Событие обновления сообщения
// }>();

// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных
// const count = ref(0); // Переменная для подсчета
// const message = ref(""); // Переменная для сообщения

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
// function changeMessage() {
//   message.value = "Новое сообщение!";
//   emits("update:message", message.value);
// }

return (_ctx: any,_cache: any) => {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_button_main = _resolveComponent("ui-button-main")!
  const _component_ui_button_delete = _resolveComponent("ui-button-delete")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_aba_button = _resolveComponent("aba-button")!
  const _component_aba_button_right = _resolveComponent("aba-button-right")!
  const _component_ui_select_autocomplete = _resolveComponent("ui-select-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", null, [
      _hoisted_2,
      _createTextVNode("  "),
      _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
    ]),
    _createVNode(_component_ui_button, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _createTextVNode("  "),
        _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_ui_button_main, null, {
      default: _withCtx(() => [
        _hoisted_4,
        _createTextVNode("  "),
        _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_ui_button_delete, null, {
      default: _withCtx(() => [
        _createTextVNode("Test4")
      ]),
      _: 1
    }),
    _createElementVNode("button", _hoisted_5, [
      _hoisted_6,
      _createTextVNode("  "),
      _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
    ]),
    _createElementVNode("button", _hoisted_7, [
      _createTextVNode("  "),
      _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
    ]),
    _createElementVNode("button", _hoisted_8, [
      _hoisted_9,
      _createTextVNode("  "),
      _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
    ]),
    _createVNode(_component_ui_input),
    _createElementVNode("div", _hoisted_10, [
      _createTextVNode(" компонет ui-input "),
      _createVNode(_component_ui_input, {
        modelValue: _ctx.Password,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Password) = $event)),
        headerText: _ctx.$localization.getTranslate('Your password'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["modelValue", "headerText", "warningMsg"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ui_input, {
          type: _ctx.isPassword ? 'Password' : 'Text',
          modelValue: _ctx.Password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Password) = $event)),
          headerText: _ctx.$localization.getTranslate('Your password'),
          warningMsg: _ctx.$localization.getTranslate('FillThisField'),
          required: ""
        }, null, 8, ["type", "modelValue", "headerText", "warningMsg"]),
        _createVNode(_component_ui_button, {
          class: "show-pass",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPassword = !_ctx.isPassword))
        }, {
          default: _withCtx(() => [
            (_ctx.isPassword)
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : (_openBlock(), _createElementBlock("img", _hoisted_14))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_aba_button, { class: "m-2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, { class: "active m-2" }, {
        default: _withCtx(() => [
          _hoisted_16,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, {
        class: "active m-2",
        isDisabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, { class: "first m-2" }, {
        default: _withCtx(() => [
          _hoisted_18,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, {
        class: "first m-2",
        btnSize: "btnLarge"
      }, {
        default: _withCtx(() => [
          _hoisted_19,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, {
        class: "first m-2",
        btnSize: "btnSmall"
      }, {
        default: _withCtx(() => [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, {
        class: "m-2",
        btnSize: "btnSmall"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button, {
        class: "m-2",
        btnSize: "btnLarge",
        btnType: "active"
      }, {
        default: _withCtx(() => [
          _hoisted_21,
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_aba_button_right, { onClick: () => {} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("SwitchOff")), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_22,
    _createVNode(_component_ui_select_autocomplete, {
      keyField: "value",
      valueField: "text",
      selectText: "value",
      items: _unref(countries),
      class: "indentification-input mr-4",
      style: {"flex":"0.5"},
      headerText: _ctx.$localization.getTranslate('Header.CountryOfIssuance') + '*',
      noUndefined: true,
      modelValue: country.value,
      "onUpdate:modelValue": [
        _cache[3] || (_cache[3] = ($event: any) => ((country).value = $event)),
        changeCountry
      ]
    }, null, 8, ["items", "headerText", "modelValue"]),
    _createTextVNode(_toDisplayString(country.value), 1)
  ]))
}
}

})